import Icon from "../Icon";
import React from "react";
import { faPen } from "@fortawesome/free-solid-svg-icons";

export interface EditButtonProps {
  onClick: () => void;
}

const EditButton = ({ onClick }: EditButtonProps) => {
  return (
    <div className="p-4 bg-white rounded-full shadow-md text-aqua">
      <button
        type="button"
        className="absolute top-0 left-0 flex items-center justify-center w-full h-full"
        onClick={onClick}
      >
        <Icon icon={faPen} />
      </button>
    </div>
  );
};

export default EditButton;
